export default __webpack_public_path__ + "static/media/bg-graphic-4@3x.48fe0dd3.png";